import { observable } from 'mobx';

export type UserResponseArgs = {
  id: number;
  name: string;
};

export type UserArgs = {
  id: number;
  name: string;
};

export const convertUserResponseToArgs = (response: UserResponseArgs) => {
  const args: UserArgs = {
    id: response.id,
    name: response.name
  };
  return args;
};

export default class User {
  @observable
  id: number;

  @observable
  name: string;

  constructor(args: UserArgs) {
    this.id = args.id;
    this.name = args.name;
  }
}
